import router from "@/router";
import getPathWithQueryParameter from "@/functions/getPathWithQueryParameter";
import store from "@/store";

export async function handleAuthError() {
    store.commit('setAuthError', {authError: true});
    return router.push({
        path: `${getPathWithQueryParameter(`/error`)}`
    });
}